import { useConditional } from '../../state/storeConditional ';
import { useTimeTableMonth } from '../../state/storeTimeTable';

const ActivateHijra = () => {
    const { updateIsOnChangeInHijra } = useConditional();
    const { HijraLocale, updateHijraLocale } = useTimeTableMonth();

    const handlerCheck = () => {
        updateIsOnChangeInHijra(true);
    };

    return (
        <div className='m-2 flex items-center gap-x-4'>
            <label htmlFor="ac" className='text-lg'>Activate Hijra Calendar</label>
            <input
                type="checkbox"
                id="ac"
                checked={HijraLocale.isActive} // Always controlled
                onChange={() => {
                    updateHijraLocale({ ...HijraLocale, isActive: !HijraLocale.isActive });
                    handlerCheck();
                }}
            />
        </div>
    );
};

export default ActivateHijra;
